(() => {
    console.log('%c👍🏼 Banner Slide In', 'color: yellow');
    const sections = document.querySelectorAll('.banner-slide-in');
    
    sections.forEach((section) => {
        const initialBg = section.classList.contains('bg-black') ? 'bg-black' : 'bg-white';
        const textAnimationClass = initialBg === 'bg-white' ? 'animate-text-white-to-pink-to-black' : null;

        const infoSections = section.querySelectorAll('[data-slide-in-from]');
        const cta = section.querySelector('.banner-slide-in__cta');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (textAnimationClass) {
                        section.classList.add(textAnimationClass);
                    }

                    infoSections.forEach((infoSection) => {
                        const direction = infoSection.dataset.slideInFrom;
                        if (direction === 'left') {
                            infoSection.classList.remove('opacity-0', '-translate-x-[50vw]');
                        } else if (direction === 'right') {
                            infoSection.classList.remove('opacity-0', 'translate-x-[50vw]');
                        }
                    });

                    cta.classList.remove('opacity-0');
                } else {
                    if (textAnimationClass) {
                        section.classList.remove(textAnimationClass);
                    }

                    infoSections.forEach((infoSection) => {
                        const direction = infoSection.dataset.slideInFrom;
                        if (direction === 'left') {
                            infoSection.classList.add('opacity-0', '-translate-x-[50vw]');
                        } else if (direction === 'right') {
                            infoSection.classList.add('opacity-0', 'translate-x-[50vw]');
                        }
                    });

                    cta.classList.add('opacity-0');
                }
            });
        }, {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin around the root
            threshold: 0.50 // trigger when 30% of the section is in view
        });

        observer.observe(section);
    });
})();